/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    actions: "actions",
    actionsEnd: "actions--end",
    actionsStart: "actions--start",
    description: "description",
    handle: "handle",
    handleActivated: "handle--activated",
    highlight: "highlight",
    icon: "icon",
    iconDot: "icon-dot",
    label: "label",
    remove: "remove",
    title: "title",
    textContainer: "text-container",
};
export const ICONS = {
    checked: "check",
    remove: "x",
};
export const SLOTS = {
    actionsEnd: "actions-end",
    actionsStart: "actions-start",
};
//# sourceMappingURL=resources.js.map
